import type { HTMLAttributes } from 'react'
import { TitleWrapper } from './styles'

interface TitleProps extends HTMLAttributes<HTMLDivElement> {
  desciption?: string
  className?: string
  level?: number
}

const Title = ({ desciption, className, ...rest }: TitleProps) => {
  return (
    <TitleWrapper>
      <div {...rest} className={`title-main ${className}`}>
        {desciption || rest.children}
      </div>
    </TitleWrapper>
  )
}
export default Title
